export default function handleMultipleCategories() {
    function applyStyles() {
        const posts = document.querySelectorAll(".post-inner-wrap");

        posts.forEach((post) => {
            const parent = post.closest(".post");
            if (parent) {
                const className = parent.className;

                if (className.includes("category-")) {
                    const categories = className.match(/category-[\w-]+/g);

                    if (categories && categories.length > 1) {
                        const ratioWrap = post.querySelector(".ratio-wrap");
                        if (ratioWrap) {
                            const color = getComputedStyle(
                                document.documentElement
                            ).getPropertyValue(
                                "--wp--preset--color--dark-blue"
                            );
                            ratioWrap.style.setProperty(
                                "border-bottom",
                                `10px solid ${color}`,
                                "important"
                            );
                        }
                    }
                }
            }
        });
    }

    // Run once on initial load
    applyStyles();

    // Detect dynamically added posts
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                applyStyles();
            }
        }
    });

    const targetNode = document.querySelector(".bb-grid.site-content-grid");
    if (targetNode) {
        observer.observe(targetNode, { childList: true, subtree: true });
    }
}
